import { render, staticRenderFns } from "./HotWordsNewsListPage.vue?vue&type=template&id=3103764b&scoped=true"
import script from "./HotWordsNewsListPage.vue?vue&type=script&lang=js"
export * from "./HotWordsNewsListPage.vue?vue&type=script&lang=js"
import style0 from "./HotWordsNewsListPage.vue?vue&type=style&index=0&id=3103764b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3103764b",
  null
  
)

export default component.exports